export default __webpack_public_path__ + "3c191f6ce81fefe9b7d1980fc9d5b4fe.png";